define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/xml",
	"ProductSpec/SizeChart",
	"./_VectorController"
], function(declare,_,xml,SizeChart,_VectorController) {

	return declare(_VectorController, {

		process: function() {
			// summary: if value is position and before the base size, then negate it (and vice-versa)
			if ((this.newValue > 0) &&
				!this._isPositiveValue() &&
				!this.ren.isAbsoluteDisplay(this._ctx) &&
				(this.keyContainer < this._getBaseIndex(this.keyContainer))) {
				this.newValue = -this.newValue;
			}

			this.inherited(arguments);
		},

		_isValueChanged: function() {
			// summary: if blank entered for new value and vectors are not yet allocated, then do not trigger change
			if (!this.inherited(arguments)) {
				return false;
			}

			return (this.oldValue != null) || (this.newValue != -999.0);
		},

		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: compute changes to increment and absolute values
			var	ranges = this._subSizeRanges;
			var index = this.keyContainer;
			var	baseIndex = this._getBaseIndex(index);
			var	node = this.getNode();
			var	cn = this.m_writer.changeNode(this.m_urlNode);
			var	key = this.keyContainer;
			var	bBase = (key == baseIndex);
			var	dDiff = SizeChart.sumDoubleValues(this.newValue, -this.oldValue);
			var	dimValues = SizeChart.getDimensionValues(this._ctx, id);
			var	value = {};

			// Pattern and PatternWithShrinkage arrays are not allocated by default, so full arrays need to be allocated
			// before they are changed for the first time.
			if (!node[id].length) {
				cn.changeAttribute(id, type, _.map(node.Increments, function(x) { return -999.0; }));
			}

			var scRevData = this._sizeChartRevision;
			if (bBase && (id == "Pattern")) {
				// if base size value changed, the other sizes will calculate based on the selected increment:
				// If the Increment values that are blank, do not drive the base size grade calculation.
				value[key] = this.newValue;

				if (SizeChart.isNotInitialized(this.oldValue)) {
					// initialize other size values from node.Increments
					if (scRevData && scRevData.isTwoDim()) {
						// On 2D size chart
						var rel = scRevData.incrementToRelative(node.Increments, this._isDisplayTwoDim);
						var n = node.Increments.length;
						for (var i = 0; i< n; i++) {
							if (!SizeChart.isNotInitialized(node.Increments[i]))
								value[i] = SizeChart.sumDoubleValues(value[key], rel[i]);
						}
					} else {
						ranges.iterate(key, null,
							function(x) {
								var relative = 0.0;
								for (var i= baseIndex - 1; i>=x; i--)
									relative = SizeChart.sumDoubleValues(relative, node.Increments[i]);

								if (!SizeChart.isNotInitialized(node.Increments[x]))
									value[x] = SizeChart.sumDoubleValues(value[key], relative);
							},
							function(x) {
								var relative = 0.0;
								for (var i= baseIndex + 1; i<=x; i++)
									relative = SizeChart.sumDoubleValues(relative, node.Increments[i]);

								if (!SizeChart.isNotInitialized(node.Increments[x]))
									value[x] = SizeChart.sumDoubleValues(value[key], relative);
							}
						);
					}
				} else if (SizeChart.isNotInitialized(this.newValue)) {
					// reset to -999.0
					var f = function(x) {
						if (!SizeChart.isNotInitialized(node.Pattern[x]) &&  !SizeChart.isNotInitialized(node.Increments[x]))
							value[x] = -999.0;
					};
					ranges.iterate(key, null, f, f);
				} else {
					// initialize other size values from node.Pattern - we do this so as to not lose previous edits to pattern
					var	oldValue = node[id];
					ranges.iterate(key, null,
						function(x) {
							if (SizeChart.isNotInitialized(node.Increments[x]))
								return;
							if (!SizeChart.isNotInitialized(node.Pattern[x]))
								value[x] = SizeChart.sumDoubleValues(oldValue[x], dDiff);
							else {
								var relative = 0.0;
								for (var i= baseIndex - 1; i>=x; i--)
									relative = SizeChart.sumDoubleValues(relative, node.Increments[i]);

								value[x] = SizeChart.sumDoubleValues(value[key], relative);
							}
						},
						function(x) {
							if (SizeChart.isNotInitialized(node.Increments[x]))
								return;
							if (!SizeChart.isNotInitialized(node.Pattern[x]))
								value[x] = SizeChart.sumDoubleValues(oldValue[x], dDiff);
							else {
								var relative = 0.0;
								for (var i= baseIndex + 1; i<=x; i++)
									relative = SizeChart.sumDoubleValues(relative, node.Increments[i]);

								value[x] = SizeChart.sumDoubleValues(value[key], relative);
							}
						}
					);
				}

				cn.changeAttributeKeys(id, type, value);
			} else {
				// if dimension showing blanks and non-empty value entered, then set Blanks to false and refresh row
				if (this.getInlineEditValue() && this.getNode().Blanks && !bBase) {
					cn.changeAttribute("Blanks", xml.ATTR_BOOLEAN, false);
				}

				if (this.ren.isAbsoluteDisplay(this._ctx)) {
					// adjust actual attribute value
					cn = this.inherited(arguments);
				} else {
					// adjust calculated absolute value based on difference between old and new values
					var comparingIndex = (index > baseIndex)? index - 1 : index + 1;  // Index of next one closer to the base size index
					if (SizeChart.isNotInitialized(this.newValue)) {
						value[index] = this.ren.DEFAULT;
						dDiff = SizeChart.sumDoubleValues(dimValues.absIgnoreBlank[comparingIndex], -dimValues.absIgnoreBlank[index]);
					} else if (SizeChart.isNotInitialized(this.oldValue)) {
						var comparingValue = (this.ren.isIncrementDisplay(this._ctx)) ?
								dimValues.absIgnoreBlank[comparingIndex] : dimValues.absIgnoreBlank[baseIndex];

						value[index] = SizeChart.sumDoubleValues(this.newValue, comparingValue);
						dDiff = SizeChart.sumDoubleValues(value[index], -dimValues.absIgnoreBlank[index]);
					} else {
						value[index] = SizeChart.sumDoubleValues(dimValues.abs[index], dDiff);
					}

					// Adjust the absolute values if Pattern to preserve the increment mode values.
					if (this.ren.isIncrementDisplay(this._ctx)) {
						var i, absValue;
						var abs = dimValues.abs;

						if (this._isDisplayTwoDim) {
							// 2D SizeChartDimension
							var iDim1 = this._sizeChartRevision.getDim1Index(index);
							var iDim2 = this._sizeChartRevision.getDim2Index(index);
							var x, y;

							var offBaseFunc = function(x, y) {
								i = this._sizeChartRevision._mapDim1ToDim2Indices[x][y];
								if (i != undefined && i >= 0) {
									absValue = abs[i];
									value[i] = (SizeChart.isNotInitialized(absValue)) ? absValue : SizeChart.sumDoubleValues(absValue, dDiff);
								}
							};

							if (iDim1 == this.baseSizeDim1Index) {
								// On base column
								if (iDim2 < this.baseSizeDim2Index) {
									// Above base size, all rows above this cell have to be updated
									for (y = iDim2 - 1; y >= 0; y--) {
										for (x = 0; x < this.dim1SizeCount; x++) {
											offBaseFunc.call(this, x, y);
										}
									}
								} else {
									// Below base size, all rows below this cell have to be updated
									for (y = iDim2 + 1; y < this.dim2SizeCount; y++) {
										for (x = 0; x < this.dim1SizeCount; x++) {
											offBaseFunc.call(this, x, y);
										}
									}
								}
							}

							if (iDim1 <= this.baseSizeDim1Index) {
								// Left or on the base column, all cells to the left have to be updated
								for (x = iDim1 - 1; x >= 0; x--) {
									offBaseFunc.call(this, x, iDim2);
								}
							}

							if (iDim1 >= this.baseSizeDim1Index) {
								// Right or on the base column, all cells to the right have to be updated
								for (x = iDim1 + 1; x < this.dim1SizeCount; x++) {
									offBaseFunc.call(this, x, iDim2);
								}
							}
						} else {
							// 1D SizeChartDimension
							var	minIndex = this._getMinIndex(index);
							var	maxIndex = this._getMaxIndex(index);

							if (index > baseIndex) {
								for(i = index+1; i <= maxIndex; i++) {
									absValue = abs[i];
									value[i] = (SizeChart.isNotInitialized(absValue)) ? absValue : SizeChart.sumDoubleValues(absValue, dDiff);
								}
							} else if (index < baseIndex) {
								for(i = index-1; i >= minIndex; i--) {
									absValue = abs[i];
									value[i] = (SizeChart.isNotInitialized(absValue)) ? absValue : SizeChart.sumDoubleValues(absValue, dDiff);
								}
							}
						}
					}

					cn.changeAttributeKeys(id, type, value);
				}
			}

			// any change requires refresh of entire row (mostly due to tolerances)
			this.bRefreshNode = true;

			return cn;
		},

		getOldValue: function() {
			// summary: If the double vector is not initialized, ie. empty, old value should be BLANK (i.e. -999.0)
			var	v = this.inherited(arguments);
			if (!v)
				v = -999.0;
			return v;
		}

	});
});